<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title"><span translate class="lblDisplay">LBL.MESSAGE_TITLE</span></h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body messageDetail">
        <div class="subSection">
            <div class="row">
                <div class="col-6"><span translate class="lblDisplay">LBL.EVENT_DESCRIPTION</span></div>
                <div class="col-6"><span translate class="lblDisplay">LBL.CALL_NO</span></div>
            </div>

            <div class="row">
                <div class="col-6">{{Model.EventDescription}}</div>
                <div class="col-6">{{Model.DisplayNo}}</div>
            </div>
        </div>

        <div class="subSection">
            <div class="row">
                <div class="col-6"><span translate class="lblDisplay">LBL.SENT_ON</span></div>
                <div class="col-6"><span translate class="lblDisplay">LBL.SENT_BY</span></div>
            </div>
            <div class="row">
                <div class="col-6">{{Model.CreatedAt | amDateFormat: DateFormat}}</div>
                <div class="col-6">{{Model.OwnerName}}</div>
            </div>
        </div>

        <div class="border-top mt-2 pt-2">
            <div class="font-weight-bold">{{Model.Subject}}</div>
            <div class="linebreak">{{Model.Message}}</div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="c()"><span translate>BTN.BTN_CLOSE</span></button>
    </div>
</ng-template>
